import { gql } from "apollo-angular";

const ACTIVE_ORGS = gql`
    query getActiveOrgs($orgType: String){ 
        activeOrgs(orgType:$orgType)
        {
         id
         name
         contactPhone
         address {
            address1
         }
         organizationType 
        }
    }
`;

export default ACTIVE_ORGS;